import React, { ReactNode } from 'react'
import styled from 'styled-components'

const StyledImg = styled.img`
  max-width: 300px;
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  gap: 20px;
    flex-direction: column;
  @media (min-width: 990px) {
    flex-direction: row;
  }
`;

const SubContainerTwo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 40px;
`;

const SubContainerThree = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
`;

const SubContainerFour = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  border: none;
  padding: 15px;
   background: #f5f5f5;
   overflow: scroll;
    max-height: 300px;
    min-height: 300px;
    border-radius: 16px;
    padding-left: 24px;
`;

const SubContainerFive = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  border: none;
  padding: 15px;
  min-height: 300px;
`;

const ATag = styled.a`
  display: block;
  margin-bottom: 10px;
      font-size: 14px;
    line-height: 20px;
    cursor: pointer;
`;

const HTag = styled.div`
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;
    font-weight: 600;
    color: #000;
`;
const PTagOne = styled.div`
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 15px;
`;

const PTag = styled.div`
    font-size: 16px;
    margin-top: 0px;
    margin-bottom: 10px;
`;

const HTagTwo = styled.div`
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #000;
`;

interface ProductResultProps {
  productResult: any;
  osVersion: string;
}

const ProductResult: React.FC<ProductResultProps> = ({ productResult, osVersion }) => {
    return (
      <>
      { productResult && productResult.title ? 
      <SubContainerTwo>
        <HTag>Search Results: {productResult.title}{ osVersion && osVersion !== '' ? ` | ${osVersion}` : null }</HTag>
        <SubContainer>
        <SubContainerThree>
        <HTagTwo>Product</HTagTwo>
        <SubContainerFive>
        <ATag className="react-no-underline" href={`/products/${productResult.handle}`}>
          <PTag>{productResult.title}</PTag>
          { productResult.featuredImage && productResult.featuredImage.originalSrc ?
          <StyledImg src={productResult.featuredImage.originalSrc} alt={productResult.title} />
          : null }
        </ATag>
        </SubContainerFive>
        </SubContainerThree>
        <SubContainerThree>
        <HTagTwo>Documents</HTagTwo>
        <SubContainerFour>
        { productResult.productSoftwareDocuments && productResult.productSoftwareDocuments.value && productResult.productSoftwareDocuments.value.documents && productResult.productSoftwareDocuments.value.documents.length > 0 ?
          productResult.productSoftwareDocuments.value.documents.map((item: any) => (
          <>
          <ATag className="react-a" key={item['path']} href={item['path']} download target="_blank">{item['document_title']}</ATag>
          </>
        )) : <PTag>None</PTag> }
        </SubContainerFour>
        </SubContainerThree>
        <SubContainerThree>
        <HTagTwo>Software Downloads</HTagTwo>
        <SubContainerFour>
        { productResult.productSoftwareDownloads && productResult.productSoftwareDownloads.value && productResult.productSoftwareDownloads.value.downloads && productResult.productSoftwareDownloads.value.downloads.length > 0 ?
         productResult.productSoftwareDownloads.value.downloads.map((item: any) => (
          <>
          <ATag className="react-a" key={item['path']} href={item['path']} download target="_blank">{item['download_title']}</ATag>
          </>
        )) : <PTag>None</PTag> }
        </SubContainerFour>
        </SubContainerThree>
        </SubContainer>
      </SubContainerTwo>
      : null }
      </>
    );
  }

export default ProductResult
